var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _g, _path2, _g2, _path3, _g3, _circle, _circle2, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailNode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 95,
    viewBox: "0 0 118 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_937_14381)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#FC8F37"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3327 16.0026C24.3327 15.6359 24.0327 15.3359 23.666 15.3359H18.3327C17.966 15.3359 17.666 15.6359 17.666 16.0026V20.0026C17.666 20.3693 17.966 20.6693 18.3327 20.6693H23.666C24.0327 20.6693 24.3327 20.3693 24.3327 20.0026V16.0026ZM23.666 16.0026L20.9993 17.6693L18.3327 16.0026H23.666ZM23.666 20.0026H18.3327V16.6693L20.9993 18.3359L23.666 16.6693V20.0026Z",
    fill: "#FFF4F0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 16,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_937_14381)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 66,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.9
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 72,
    width: 12,
    height: 12,
    rx: 2,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 76,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_937_14381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 66.2652C58.8813 66.4116 59.1187 66.4116 59.2652 66.2652L61.6517 63.8787C61.7981 63.7322 61.7981 63.4948 61.6517 63.3483C61.5052 63.2019 61.2678 63.2019 61.1213 63.3483L59 65.4697L56.8787 63.3483C56.7322 63.2019 56.4948 63.2019 56.3484 63.3483C56.2019 63.4948 56.2019 63.7322 56.3484 63.8787L58.7348 66.2652ZM58.625 55L58.625 56.375L59.375 56.375L59.375 55L58.625 55ZM58.625 57.2917L58.625 60.0417L59.375 60.0417L59.375 57.2917L58.625 57.2917ZM58.625 60.9583L58.625 63.7083L59.375 63.7083L59.375 60.9583L58.625 60.9583ZM58.625 64.625L58.625 66L59.375 66L59.375 64.625L58.625 64.625Z",
    fill: "#7DB9FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 66.2652C58.8813 66.4116 59.1187 66.4116 59.2652 66.2652L61.6517 63.8787C61.7981 63.7322 61.7981 63.4948 61.6517 63.3483C61.5052 63.2019 61.2678 63.2019 61.1213 63.3483L59 65.4697L56.8787 63.3483C56.7322 63.2019 56.4948 63.2019 56.3484 63.3483C56.2019 63.4948 56.2019 63.7322 56.3484 63.8787L58.7348 66.2652ZM58.625 55L58.625 57.2917L59.375 57.2917L59.375 55L58.625 55ZM58.625 58.2083L58.625 62.7917L59.375 62.7917L59.375 58.2083L58.625 58.2083ZM58.625 63.7083L58.625 66L59.375 66L59.375 63.7083L58.625 63.7083Z",
    fill: "#42CFEF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_937_14381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 30L59 38",
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeDasharray: "3 1"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30L59 38",
    stroke: "#42CFEF",
    strokeWidth: 0.75,
    strokeDasharray: "5 1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_937_14381)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 46.75,
    r: 8.25,
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 46.75,
    r: 8.25,
    stroke: "#42CFEF",
    strokeWidth: 0.5,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.75,
    cy: 46.75,
    r: 6.75,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62 44H56C55.5875 44 55.2537 44.3375 55.2537 44.75L55.25 49.25C55.25 49.6625 55.5875 50 56 50H62C62.4125 50 62.75 49.6625 62.75 49.25V44.75C62.75 44.3375 62.4125 44 62 44ZM61.85 45.5938L59.1988 47.2513C59.0787 47.3263 58.9213 47.3263 58.8012 47.2513L56.15 45.5938C56.1124 45.5726 56.0795 45.5441 56.0532 45.5099C56.0269 45.4757 56.0079 45.4365 55.9972 45.3948C55.9865 45.353 55.9844 45.3095 55.9911 45.2669C55.9977 45.2243 56.0129 45.1834 56.0357 45.1469C56.0586 45.1103 56.0886 45.0787 56.124 45.0541C56.1594 45.0295 56.1995 45.0123 56.2417 45.0036C56.2839 44.9949 56.3275 44.9949 56.3697 45.0035C56.412 45.0121 56.452 45.0292 56.4875 45.0538L59 46.625L61.5125 45.0538C61.548 45.0292 61.588 45.0121 61.6303 45.0035C61.6725 44.9949 61.7161 44.9949 61.7583 45.0036C61.8005 45.0123 61.8406 45.0295 61.876 45.0541C61.9114 45.0787 61.9414 45.1103 61.9643 45.1469C61.9871 45.1834 62.0023 45.2243 62.0089 45.2669C62.0156 45.3095 62.0135 45.353 62.0028 45.3948C61.9921 45.4365 61.9731 45.4757 61.9468 45.5099C61.9205 45.5441 61.8876 45.5726 61.85 45.5938Z",
    fill: "#394353"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_937_14381",
    x: 0,
    y: 0,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_937_14381"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_937_14381"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_937_14381",
    result: "effect2_dropShadow_937_14381"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_937_14381",
    result: "effect3_dropShadow_937_14381"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_937_14381",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_937_14381",
    x: 0,
    y: 60,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_937_14381"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_937_14381"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_937_14381",
    result: "effect2_dropShadow_937_14381"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_937_14381",
    result: "effect3_dropShadow_937_14381"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_937_14381",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_937_14381",
    x: 48.2383,
    y: 47,
    width: 21.5234,
    height: 27.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_937_14381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_937_14381",
    x: 50.625,
    y: 22,
    width: 16.75,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_937_14381"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_937_14381",
    x: 47.126,
    y: 35.125,
    width: 23.25,
    height: 23.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_937_14381"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailNode);
export default __webpack_public_path__ + "static/media/emailNode.f6d9fcfa9ff82cba02f7c8ff96085ee0.svg";
export { ForwardRef as ReactComponent };